<template>
  <div>
    <div v-if="getTaskPreparedEdit > -1">
      {{ prepareEdit(getTaskPreparedEdit) }}
    </div>
    <div v-if="getAxiosRefresh == 3">{{ initData() }}</div>
    <div v-if="getSaveData.length == elementsCount">{{ saveData() }}</div>
    <div
      v-if="localShowTaskIndex > -2 && localShowTaskIndex != getShowTaskIndex"
    >
      {{ prepareRead() }}
    </div>

    <v-layout row wrap v-if="myContent">
      <v-card-text>
        <JptrCore />
      </v-card-text>
      <v-expansion-panels v-model="panels" multiple flat class="px-6">
        <v-expansion-panel>
          <v-expansion-panel-header><b>Content</b></v-expansion-panel-header>
          <v-expansion-panel-content>
            <!-- show -->
            <v-layout row wrap class="py-2">
              <v-flex
                :xs12="getTaskVertic"
                :xs6="!getTaskVertic"
                v-if="getShowTaskIndex > -1"
                :class="[
                  'card-border-style position-relative overflow-hidden read-only--background read-only--border-color',
                  getTaskVertic == true
                    ? 'rounded-tl-lg rounded-tr-lg'
                    : 'rounded-tl-lg rounded-bl-lg',
                ]"
              >
                <div
                  v-if="
                    myContent.languages[getShowTaskIndex].permissions &&
                    !myContent.islocked
                  "
                  class="universal-row-item__group-btn-panel read-only--border-color"
                >
                  <div class="lang-side">
                    <img
                      class="lang-side__img"
                      :src="getLanguageIcons[getShowTaskIndex].url"
                    />
                  </div>
                  <v-icon @click="prepareEdit(getShowTaskIndex)" dense
                    >edit</v-icon
                  >
                  <v-icon @click="clearTranslation(getShowTaskIndex)" dense
                    >delete</v-icon
                  >
                  <v-icon
                    v-if="myContent.languages[getShowTaskIndex].visible == 0"
                    @click="changeVisibility(getShowTaskIndex)"
                    dense
                    >visibility_off</v-icon
                  >
                  <v-icon
                    v-else
                    @click="changeVisibility(getShowTaskIndex)"
                    dense
                    >visibility</v-icon
                  >
                  <v-icon
                    class="border-l read-only--border-color"
                    @click="
                      $store.commit('setShowTaskIndex', -1);
                      $store.commit('setTaskVertic', true);
                    "
                    dense
                    >cancel</v-icon
                  >
                </div>
                <xReadContent
                  v-bind:id="2"
                  v-bind:format="'json'"
                  v-bind:my_element="
                    myContent.languages[getShowTaskIndex].content
                  "
                  v-bind:runnable="false"
                  v-bind:user_course_id = "-1"
                />
              </v-flex>

              <!-- edit -->
              <v-flex
                :xs12="getTaskVertic"
                :xs6="!getTaskVertic"
                v-if="getEditTaskIndex > -1"
                :class="[
                  'card-border-style position-relative overflow-hidden',
                  getShowTaskIndex > -1 && getTaskVertic == false
                    ? 'border-l-none rounded-tr-lg rounded-br-lg'
                    : '',
                  getShowTaskIndex > -1 && getTaskVertic == true
                    ? 'border-t-none rounded-br-lg rounded-bl-lg'
                    : '',
                  getShowTaskIndex > -1 ? '' : 'rounded-lg',
                ]"
              >
                <div class="universal-row-item__group-btn-panel">
                  <div class="lang-side">
                    <img
                      class="lang-side__img"
                      :src="getLanguageIcons[getEditTaskIndex].url"
                    />
                  </div>

                  <v-icon
                    v-if="getShowTaskIndex > -1"
                    title="copy all content"
                    @click="copyContent()"
                    dense
                    >content_copy</v-icon
                  >
                </div>

                <v-card-text>
                  <v-layout row wrap class="pa-2">
                    <v-flex xs12>
                      <xRWContent
                        v-bind:id="1"
                        v-bind:format="'json'"
                        v-bind:my_element="
                          myContent.languages[getEditTaskIndex].content
                        "
                      />
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-layout>

    <v-layout
      v-if="myContent && getEditTaskIndex > -1"
      class="d-flex align-end flex-column border-t mt-5 pa-2"
    >
      <div class="btn-group-a">
        <img
          class="btn-group-a__divider-item"
          :src="getLanguageIcons[getEditTaskIndex].url"
          width="20"
        />
        <v-icon
          v-if="
            !myContent.islocked &&
            !(myContent.id > 0 && getCountdownStatus.count <= 0)
          "
          title="save without close"
          @click="
            requestSaveData(
              false,
              getEditTaskIndex,
              objectChangePermission ? 0 : 1
            )
          "
          class="btn-group-a__button btn-group-a__button--green"
          dense
          >save</v-icon
        >
        <v-icon
          v-if="
            !myContent.islocked &&
            !(myContent.id > 0 && getCountdownStatus.count <= 0)
          "
          title="save and close"
          @click="
            requestSaveData(
              true,
              getEditTaskIndex,
              objectChangePermission ? 0 : 1
            )
          "
          class="btn-group-a__button btn-group-a__button--blue"
          dense
          >check_circle</v-icon
        >
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../../axios-auth";
import xReadContent from "../../../../components/jprcomponents/etype_xread_content.vue";
import xRWContent from "../../../../components/jprcomponents/etype_xrw_content.vue";
import JptrCore from "../../../../components/jprcomponents/jptr_core.vue";

export default {
  data() {
    return {
      showedHTML: false,
      myContent: null,
      tmpContent: "",
      panels: [0],
      elementsCount: 1, // count of elements for save
      saveRequestParameters: { close: false, index: 0, onlyTran: 1 },
      localShowTaskIndex: -2, // starting value
    };
  },
  props: {
    my_element: Object,
    objectChangePermission: Boolean,
  },
  computed: mapGetters([
    "getLanguageIcons",
    "getCountdownStatus",
    "getShowTaskIndex",
    "getEditTaskIndex",
    "getTaskVertic",
    "getTaskPreparedEdit",
    "getAxiosRefresh",
    "getSaveData",
  ]),
  components: {
    xReadContent,
    xRWContent,
    JptrCore,
  },
  mounted() {
    if (this.getAxiosRefresh != 3) this.initData();
  },
  methods: {
    // ************ main methods
    getEditorOption() {
      return es.getEditorOption();
    },
    getCmOptions() {
      return es.getCmOptions("text/html", false);
    },
    changeVisibility(_index) {
      this.$store.commit(
        "setTaskNewVisibility",
        1 - this.myContent.languages[_index].visible
      );
      this.$store.commit("setTaskChangeVisibility", true);
      this.myContent.languages[_index].visible =
        1 - this.myContent.languages[_index].visible;
    },
    prepareEdit(_index) {
      this.$store.commit("setTaskPreparedEdit", -1);
      if (
        !this.myContent.languages[_index].permissions ||
        this.myContent.islocked
      )
        return;
      this.$store.commit("setEditTaskIndex", _index);
      this.$store.commit("pushToUpdateList", 1);
    },
    prepareRead() {
      this.localShowTaskIndex = this.getShowTaskIndex;
      this.$store.commit("pushToUpdateList", 2);
    },
    closeTask() {
      this.$router.go(-1);
    },

    // ******** end of main methods
    // *********************************

    initData() {
      this.$store.commit("setAxiosRefresh", -1);

      this.myContent = this.my_element;
      if (
        this.getEditTaskIndex > -1 &&
        (!this.myContent.languages[this.getEditTaskIndex].permissions ||
          this.myContent.islocked)
      ) {
        this.$store.commit("setEditTaskIndex", -1);
        this.$store.commit("setTaskVertic", true);
      }
      if (this.getShowTaskIndex == this.getEditTaskIndex) {
        this.$store.commit("setShowTaskIndex", -1);
        this.$store.commit("setTaskVertic", true);
        this.prepareEdit(this.getEditTaskIndex);
      }
      this.localShowTaskIndex = this.getShowTaskIndex;
    },
    copyContent() {
      if (this.getShowTaskIndex == -1) return;
      this.myContent.languages[this.getEditTaskIndex].content =
        this.myContent.languages[this.getShowTaskIndex].content;
      this.$store.commit("pushToUpdateList", 1);
    },
    clearTranslation(_index) {
      if (!this.myContent.languages[_index].translated) return;
      this.tmpContent = "";
      this.requestSaveData(false, _index, 1);
      this.$store.commit("setShowTaskIndex", -1);
    },
    requestSaveData(_close, _index, _only_translation) {
      this.saveRequestParameters.close = _close;
      this.saveRequestParameters.index = _index;
      this.saveRequestParameters.onlyTran = _only_translation;
      this.$store.commit("setSavePrepareListToEmpty");
      this.$store.commit("setSaveDataToEmpty");
      this.$store.commit("pushToSavePrepareList", 1);
    },
    saveData() {
      const _data = this.getSaveData;
      this.$store.commit("setSaveDataToEmpty");
      //console.log(_data)

      const _saveData = {
        task_id: this.myContent.id,
        course_id: this.myContent.course_id, // will be checked on backend
        lesson_id: this.myContent.lesson_id,
        task_type: "C",
        task_type_id: this.myContent.task_type_id,
        max_score: this.myContent.max_score,
        // task_order: this.myContent.task_order,
        content: JSON.stringify(_data[0].data), // new data
        globals: "",
        lang_id: Number.parseInt(this.saveRequestParameters.index) + 1,
        only_translation: this.saveRequestParameters.onlyTran,
      };

      axios
        .post("/edit-task", _saveData, this.$store.getters.getAxiosConfig)
        .then((res) => {
          if (res.data.message != "OK") {
            this.$store.commit("setFeedback", res.data.message);
            return;
          }
          if (this.myContent.id == 0) {
            // new - refresh
            this.myContent.id = res.data.task_id;

            this.$store.commit(
              "setShowTaskIndex",
              this.saveRequestParameters.index
            );
            this.$store.commit(
              "setEditTaskIndex",
              this.saveRequestParameters.index
            );

            this.$router.replace({
              name: "task_edit",
              params: {
                id: this.myContent.id,
                id_type: this.myContent.task_type_id,
                show_lang: this.saveRequestParameters.index,
                edit_lang: this.saveRequestParameters.index,
                course_id: this.myContent.course_id,
                lesson_id: this.myContent.lesson_id,
              },
            });
          }
          if (this.saveRequestParameters.close) this.closeTask();
          this.$store.commit("setAxiosRefresh", 1);
        })
        .catch((error) => {
          this.$store.commit("setFeedback", error);
        });
    },
  },
};
</script>

<style></style>
